export const getFormattedValues = (dynamicFields) => {
  const formattedValues = {};
  dynamicFields?.forEach((field) => {
    formattedValues[field.keyword] = field.value;
  });
  return formattedValues;
};
